export const RESEARCH_ACTIONS = new Set([
  'research',
  'deep_search',
  'source_explore',
  'document_explore',
  'api_query',
  'data_analysis',
])

export const DOCUMENT_ACTIONS = new Set([
  'create_presentation',
  'create_document',
  'create_pdf',
  'create_spreadsheet',
  'convert_document',
])

export const FILE_ACTIONS = new Set(['build', 'build_project', 'modify_code', 'write_file'])
export const PLANNING_ACTIONS = new Set(['scope', 'scope.plan', 'planning', 'plan'])
export const TOOL_DETAIL_PATTERN = /^Used \d+ tools?(?: · (?:working|done|needs attention))?$/
export const FRIENDLY_DETAIL_PATTERN =
  /^(Planning|Researching|Reviewing sources|Generating document|Writing files|Checking the result|Working) · (working|done|needs attention)$/
